import { CALL_API } from "redux-api-middleware";
import api from "apis/webOrder";
import {
  REQUEST_WEBORDER_UPDATE,
  RECEIVE_WEBORDER_UPDATE,
  ERROR_WEBORDER_UPDATE,
  REQUEST_LOCAL_TIME,
  RECEIVE_LOCAL_TIME,
  ERROR_LOCAL_TIME,
  REQUEST_BROKER_LENDERS,
  RECEIVE_BROKER_LENDERS,
  ERROR_BROKER_LENDERS,
  REQUEST_BROKER_REPORT_TYPES,
  RECEIVE_BROKER_REPORT_TYPES,
  ERROR_BROKER_REPORT_TYPES,
  REQUEST_APPOINTMENT_HOLIDAYS,
  RECEIVE_APPOINTMENT_HOLIDAYS,
  ERROR_APPOINTMENT_HOLIDAYS,
  RESET_WEB_ORDER,
  REQUEST_CHECKOUT_GET, RECEIVE_CHECKOUT_GET, ERROR_CHECKOUT_GET,
  REQUEST_CHECKOUT_SAVE, RECEIVE_CHECKOUT_SAVE, ERROR_CHECKOUT_SAVE,
  REQUEST_CHECKOUT_CANCEL, RECEIVE_CHECKOUT_CANCEL, ERROR_CHECKOUT_CANCEL,
  REQUEST_BROKER_BILLING_PREVIEW, RECEIVE_BROKER_BILLING_PREVIEW, ERROR_BROKER_BILLING_PREVIEW,
} from "typeConstants";
import responseHandler from "responseHandler";
import { push } from "react-router-redux";

const createOrder = (webOrder, fileList, callback) => {
  if (callback === null) {
    return dispatch => {
      dispatch({ type: "" });
    };
  }
  let payType = parseInt(webOrder.selectedPaymentType);

  if (!payType) payType = 1;

  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: api.createBrokerWebOrder(),
        method: "POST",
        body: JSON.stringify({
          CustomerNumber: webOrder.lender,
          ReportType: webOrder.reportType,
          BrokerAgent: webOrder.agentCode,
          TransactionType: webOrder.transactionType === "Other" ? webOrder.transactionTypeOther : webOrder.transactionType,
          Loan: {
            LenderName: webOrder.lender,
            LoanNumber: webOrder.loanNumber,
            DesktopUnderwriterCasefileID: webOrder.desktopUnderwriterCasefileID,
            FreddieMacCaseFileId: webOrder.freddieMacCaseFileId,
            PropertyType: webOrder.propertyType
          },
          Borrower: {
            FirstName: webOrder.borrowerFirstName,
            LastName: webOrder.borrowerLastName,
            EmailAddress: webOrder.borrowerEmail ? webOrder.borrowerEmail : null,
            PhoneNumber1: webOrder.borrowerPhone1,
            PhoneNumber2: webOrder.borrowerPhone2,
            NoValidEmail: webOrder.noBorrowerEmail,
            BorrowerAddress: {
              Address1: webOrder.borrowerAddress1,
              Address2: webOrder.borrowerAddress2,
              City: webOrder.borrowerCity,
              State: webOrder.borrowerState,
              ZipCode: webOrder.borrowerZip,
            },
          },
          InspectionAddress: {
            Address1: webOrder.inspectionAddress1,
            Address2: webOrder.inspectionAddress2,
            City: webOrder.inspectionCity,
            State: webOrder.inspectionState,
            ZipCode: webOrder.inspectionZip
          },
          Appointment: {
            Occupancy: webOrder.occupancy,
            AccessToProperty: webOrder.accessToProperty,
            Contact: {
              FirstName: webOrder.appointmentContactFirstName,
              LastName: webOrder.appointmentContactLastName,
              PhoneNumber1: webOrder.appointmentContactPhone1,
              PhoneNumber2: webOrder.appointmentContactPhone2,
              EmailAddress: webOrder.appointmentContactEmail,
              Role: webOrder.contactRole
            },
            PreferredAppointmentDate: webOrder.preferredAppointmentDate,
            PreferredAppointmentWindow: webOrder.preferredAppointmentWindow,
            LockboxCode: webOrder.lockboxCode
          },
          PaymentType: payType,
          Billing: {
            CardNumber: payType !== 1 ? "NA000000000000" : webOrder.cardNumber.replace(/ /g, ""),
            ExpirationDate: payType !== 1 ? "2025-01" : (webOrder.cardExpirationYear + "-" + webOrder.cardExpirationMonth),
            CCV: payType !== 1 ? "000" : webOrder.cardCVC,
            CardHolder: payType !== 1 ? "NA" : webOrder.cardName
          },
          Attachments: fileList.map(file => file.muellerFileId)
        }),
        types: [
          REQUEST_WEBORDER_UPDATE,
          {
            type: RECEIVE_WEBORDER_UPDATE,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  setTimeout(() => {
                    if (data.error) {
                      responseHandler.clientErrors(data.errorMessages, dispatch);
                      if (callback) callback(false);
                    }
                    else {
                      responseHandler.success("Order Processed", dispatch);
                      if (callback) callback(true);
                    }
                  }, 200);
                  return data;
                })
          },
          {
            type: ERROR_WEBORDER_UPDATE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
              if (callback) callback(false);
              return webOrder;
            }
          }
        ]
      }
    })
  );
};

const uploadFile = (file, fileId, uploadFinishedCallback) => {
  const data = new FormData();
  data.append("file", file);

  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: api.uploadFile(),
        method: "POST",
        body: data,
        requestType: "upload", //this will get picked up in the middlewares/genericHeaders/index.js and it will delete our Content-Type that it usually sets so the browser can generate a proper Content-Type
        types: [
          REQUEST_WEBORDER_UPDATE,
          {
            type: RECEIVE_WEBORDER_UPDATE,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  setTimeout(() => {
                    if (data.error) {
                      responseHandler.clientErrors(data.errorMessages, dispatch);
                    }
                    else {
                      uploadFinishedCallback(fileId, data);
                    }
                  }, 0);
                  return data;
                })
          },
          {
            type: ERROR_WEBORDER_UPDATE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
              return;
            }
          }
        ]
      }
    })
  );
};

const uploadFileToCase = (controlNumber, file, fileId, uploadFinishedCallback) => {
  const data = new FormData();
  data.append("file", file);

  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: api.uploadFileToCase(controlNumber),
        method: "POST",
        body: data,
        requestType: "upload", //this will get picked up in the middlewares/genericHeaders/index.js and it will delete our Content-Type that it usually sets so the browser can generate a proper Content-Type
        types: [
          REQUEST_WEBORDER_UPDATE,
          {
            type: RECEIVE_WEBORDER_UPDATE,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  setTimeout(() => {
                    if (data.error) {
                      responseHandler.clientErrors(data.errorMessages, dispatch);
                    }
                    else {
                      uploadFinishedCallback(fileId, data);
                    }
                  }, 0);
                  return data;
                })
          },
          {
            type: ERROR_WEBORDER_UPDATE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
              return;
            }
          }
        ]
      }
    })
  );
};

const removeFile = (fileId) => {
  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: api.removeFile(fileId),
        method: "POST",
        types: [
          REQUEST_WEBORDER_UPDATE,
          {
            type: RECEIVE_WEBORDER_UPDATE,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  setTimeout(() => {
                  }, 0);
                  return data;
                })
          },
          {
            type: ERROR_WEBORDER_UPDATE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
              return;
            }
          }
        ]
      }
    })
  );
};

const removeFileFromCase = (controlNumber, fileId) => {
  return dispatch => (
    dispatch({
      [CALL_API]: {
        endpoint: api.removeFileFromCase(controlNumber, fileId),
        method: "POST",
        types: [
          REQUEST_WEBORDER_UPDATE,
          {
            type: RECEIVE_WEBORDER_UPDATE,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  setTimeout(() => {
                  }, 0);
                  return data;
                })
          },
          {
            type: ERROR_WEBORDER_UPDATE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
              return;
            }
          }
        ]
      }
    })
  );
};

//when i wrote this i did not understand the way that we could pass data back to the page with the reducer
//this could probably be changed to use a reducer rather easily
const getLocalTimeZone = (postalCode, receiveTimeCallback) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.localTime(postalCode),
        method: "GET",
        types: [
          REQUEST_LOCAL_TIME,
          {
            type: RECEIVE_LOCAL_TIME,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  setTimeout(() => {
                    if (data.error) {
                      responseHandler.clientErrors(`Error getting local time for postal code ${postalCode}: ${data.errorMessages}`, dispatch);
                    }
                    else {
                      receiveTimeCallback(postalCode, data);
                    }
                  }, 0);
                  return data;
                })
          }, {
            type: ERROR_LOCAL_TIME,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getLenders = () => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.lenders(),
        method: "GET",
        types: [
          REQUEST_BROKER_LENDERS,
          {
            type: RECEIVE_BROKER_LENDERS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_BROKER_LENDERS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getReportTypes = (lender) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.reportTypes(lender),
        method: "GET",
        types: [
          REQUEST_BROKER_REPORT_TYPES,
          {
            type: RECEIVE_BROKER_REPORT_TYPES,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_BROKER_REPORT_TYPES,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getBillingPreview = (billingInfo) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.getBillingPreview(),
        body: JSON.stringify(billingInfo),
        method: "POST",
        types: [
          REQUEST_BROKER_BILLING_PREVIEW,
          {
            type: RECEIVE_BROKER_BILLING_PREVIEW,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_BROKER_BILLING_PREVIEW,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const getHolidays = () => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.holidays(),
        method: "GET",
        types: [
          REQUEST_APPOINTMENT_HOLIDAYS,
          {
            type: RECEIVE_APPOINTMENT_HOLIDAYS,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  return data;
                })
          }, {
            type: ERROR_APPOINTMENT_HOLIDAYS,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

const pushToConfirmationPage = () => {
  return dispatch => dispatch(push("/order-confirmation"));
};

const resetWebOrder = () => {
  return ((dispatch) => {
    dispatch({ type: RESET_WEB_ORDER, payload: null });
  });
};

const getCheckout = (token, controlNumber) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.getCheckout(token, controlNumber),
        method: "GET",
        types: [
          REQUEST_CHECKOUT_GET,
          {
            type: RECEIVE_CHECKOUT_GET,
            payload: (action, state, res) =>
              res.json().then(data => { return data; })
          }, {
            type: ERROR_CHECKOUT_GET,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};

// this method handles Checkout and Reorder (token = "reorder")
const saveCheckout = (token, webOrder, callback) => {
  if (callback === null) {
    return dispatch => {
      dispatch({ type: "" });
    };
  }
  // reorder can specify payment type, Checkout is alway Pay Now == 1
  let bodyData = {};
  if (token == "reorder") {
    let payType = parseInt(webOrder.selectedPaymentType);
    // C# class WebReorderRequest
    bodyData = {
      OriginalControlIdNumber: webOrder.originalControlIdNumber,
      NewReportTypeCode: webOrder.reportType,
      PaymentType: payType,
      Billing: {
        CardNumber: payType !== 1 ? "NA000000000000" : webOrder.cardNumber.replace(/ /g, ""),
        ExpirationDate: payType !== 1 ? "2025-01" : (webOrder.cardExpirationYear + "-" + webOrder.cardExpirationMonth),
        CCV: payType !== 1 ? "000" : webOrder.cardCVC,
        CardHolder: payType !== 1 ? "NA" : webOrder.cardName
      }
    };
  }
  else {
    // C# class WebOrderCheckoutSave
    bodyData = {
      token: token,
      Billing: {
        CardNumber: webOrder.cardNumber.replace(/ /g, ""),
        ExpirationDate: webOrder.cardExpirationYear + "-" + webOrder.cardExpirationMonth,
        CCV: webOrder.cardCVC,
        CardHolder: webOrder.cardName
      }
    };
  }


  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.saveCheckout(token, webOrder.originalControlIdNumber),
        method: "POST",
        body: JSON.stringify(bodyData),
        types: [
          REQUEST_CHECKOUT_SAVE,
          {
            type: RECEIVE_CHECKOUT_SAVE,
            payload: (action, state, res) =>
              res.json()
                .then(data => {
                  setTimeout(() => {
                    if (data.error) {
                      responseHandler.clientErrors(data.errorMessages, dispatch);
                      if (callback) callback(false);
                    }
                    else {
                      responseHandler.success("Order Processed", dispatch);
                      if (callback) callback(true);
                    }
                  }, 200);
                  return data;
                })
          }, {
            type: ERROR_CHECKOUT_SAVE,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
              if (callback) callback(false);
            }
          }
        ]
      }
    });
  };
};

const cancelCheckout = (item) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        endpoint: api.cancelCheckout(item),
        method: "POST",
        types: [
          REQUEST_CHECKOUT_CANCEL,
          {
            type: RECEIVE_CHECKOUT_CANCEL,
            payload: (action, state, res) =>
              res.json().then(data => { return data; })
          }, {
            type: ERROR_CHECKOUT_CANCEL,
            payload: (action, state, res) => {
              responseHandler.error(res, dispatch);
            }
          }
        ]
      }
    });
  };
};


export {
  createOrder,
  uploadFile,
  uploadFileToCase,
  removeFile,
  removeFileFromCase,
  getLocalTimeZone,
  pushToConfirmationPage,
  getLenders,
  getReportTypes,
  getHolidays,
  resetWebOrder,
  getCheckout,
  cancelCheckout,
  saveCheckout,
  getBillingPreview
};